/* unplugin-vue-components disabled */import script from "./ListInteraction.vue?vue&type=script&setup=true&lang=js"
export * from "./ListInteraction.vue?vue&type=script&setup=true&lang=js"

import "./ListInteraction.vue?vue&type=style&index=0&id=d2474132&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2474132"]])

export default __exports__